import { AutogenModelTariffRegionLoc, AutogenRowTariffRegionLoc } from "./autogen/AutogenModelTariffRegionLoc";

export class ModelTariffRegionLoc extends AutogenModelTariffRegionLoc<RowTariffRegionLoc> {
	constructor() {
		super(RowTariffRegionLoc);
	}
}

export class RowTariffRegionLoc extends AutogenRowTariffRegionLoc {
}